// CheckboxShareModal.js

import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button as UiButton } from "../../../components";
import axios from "axios";
import * as APITypes from "../../../constants/API";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";

const CheckboxShareModal = (props) => {
  const [checkboxList, setCheckboxList] = useState([]);
  const fetchDocumentList = async () => {
    const solutionIds = JSON.parse(localStorage.getItem("solutionList"));
    const idsAsString = solutionIds.toString();

    const response = await axios.get(
      APITypes.GET_DOCUMENT_LIST + `?ids=${idsAsString}`
    );
    if (response.data && response.status == "success") {
      setCheckboxList(response?.data);
    } else {
      props.proceedSoluctionToQmsScreen(
        getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchDocumentList();
        if (response.data?.length > 0) {
          setCheckboxList(response?.data);
        }
      } catch (error) {
        console.log("Error for Share Customer Modal");
      }
    };
    fetchData();
  }, []);

  const handleCheckboxChange = (solutionId, documentId) => {
    setCheckboxList((prevList) => {
      const updatedList = prevList.map((solution) => {
        if (solution.solution_id === solutionId) {
          const updatedDocuments = solution.document_list.map((document) => {
            if (document.id === documentId) {
              return { ...document, is_selected: !document.is_selected };
            }
            return document;
          });
          return { ...solution, document_list: updatedDocuments };
        }
        return solution;
      });
      return updatedList;
    });
  };

  console.log(checkboxList, "checkBoxList");

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className="save-session-modal"
      show={props.show}
      keyboard={false}
    >
      <Modal.Body className="">
        <React.Fragment>
          <div>
            <p className="text-center align-items-center font-size-20">
              Select the below product for sharing the documents
            </p>
            <div>
              {checkboxList?.map((solution, index) => (
                <div key={solution?.solution_id}>
                  <p className="font-weight-bold">
                    {index + 1}. {solution?.member_type}
                  </p>
                  {solution?.document_list?.length > 0 &&
                    solution?.document_list.map((document, index) => (
                      <>
                          <div key={document.id}>
                            <input
                              className="mx-2"
                              type="checkbox"
                              checked={document?.is_selected}
                              onChange={() =>
                                handleCheckboxChange(
                                  solution?.solution_id,
                                  document?.id
                                )
                              }
                            />
                            <label>{document?.document_label}</label>
                          </div>
                      </>
                    ))}
                </div>
              ))}
            </div>
          </div>
        </React.Fragment>
      </Modal.Body>
      <Modal.Footer className="d-block p-4 border-0">
        <Row className="modal-footer-row">
          <React.Fragment>
            <div className="col-12 col-lg-6 mb-3 mb-lg-0  order-0 order-lg-0 pr-lg-1">
              <button
                type="submit"
                // disabled={formController.$("proceed_btn").disabled}
                className="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 font-size-14 font-weight-medium"
                onClick={() => props.yesShowCheckboxShareModal(checkboxList)}
              >
                Share
              </button>
            </div>
            <div className="col-12 col-lg-6 mb-3 mb-lg-0  order-0 order-lg-0 pr-lg-1">
              <button
                className="btn btn-link btn-lg modal-cta-btn modal-cta-btn-link py-2 py-lg-1 font-size-14 font-weight-medium"
                // onClick={() => Utils.handleModalExit(remainingProps, hideModal)}
                onClick={props.noShowCheckboxShareModal}
              >
                Cancel
              </button>
            </div>
          </React.Fragment>
        </Row>
      </Modal.Footer>
    </Modal >
  );
};

export default CheckboxShareModal;
